import { Action, createReducer, on } from '@ngrx/store';
import { StateBuilder } from '../../../model/state.builder';
import { PersonaActions } from './persona.actions';
import { IPersonaState } from './persona.state';

export const initialPersonaState: IPersonaState = {
  model: undefined,
  data: undefined,
  uiState: undefined
};

const personaReducerFn = createReducer(
  initialPersonaState,
  on(PersonaActions.reset, (state: IPersonaState, action) => {
    return new StateBuilder<IPersonaState>(initialPersonaState).build();
  }),
  on(PersonaActions.load, (state: IPersonaState, action) => {
    return new StateBuilder<IPersonaState>(state).toLoading().build();
  }),
  on(PersonaActions.loadSuccess, (state: IPersonaState, action) => {
    return new StateBuilder<IPersonaState>(state, action).toLoaded().build();
  }),
  on(PersonaActions.submit, (state: IPersonaState, action) => {
    return new StateBuilder<IPersonaState>(state).toLoading().build();
  }),
  on(PersonaActions.submitSuccess, (state: IPersonaState, action) => {
    return new StateBuilder<IPersonaState>(state, action).toLoaded().build();
  })
);

export function personaReducer(state: IPersonaState | undefined, action: Action) {
  return personaReducerFn(state, action);
}
